'use strict';

angular.module('app')

.service('linkModal', function (
    hyperlinkEditModal,
    $q
) {
    var modalInstance;

    this.open = open;
    this.click = click;

    function open()
    {
        modalInstance = hyperlinkEditModal.open();

        return modalInstance.result.then(function (result) {
            var defer = $q.defer();
            defer.resolve(result);
            return defer.promise;
        });
    }

    function click($event, attributes)
    {
        if (modalInstance) {
            modalInstance.dismiss();
        }

        if (attributes.href && attributes.href === '#') {
            $event.preventDefault();
        }
    }
});
